import { PAIRED_CARD_FIELD_ROWS } from 'components/Payments/payroc/lib/cardFieldRows';

import NewCard from '../../PayWithCardModal/NewCard';
import { useReportFormLoadError } from '../lib/formLoadErrorContext';

const PairedNewCard = (props) => {
  const reportLoadError = useReportFormLoadError();

  return <NewCard {...props} fieldRows={PAIRED_CARD_FIELD_ROWS} onLoadError={reportLoadError} />;
};

export default PairedNewCard;
